module.exports = __webpack_public_path__ + "media/img/retention-illustration-7176c7aa3a2c19c001cf4ba446c9dd00.png";